module.exports = __webpack_public_path__ + "static/media/fungoxyl.6baa922e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/tizon_tardio_papa/curativa/fungoxyl.png
// module id = 2012
// module chunks = 3